import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/bilirubinDirect";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	bilirubinDirect: {
		id: "ktx.bilirubinDirect.title",
		defaultMessage: "Bilirubin (direkt)"
	},
	value: {
		id: "ktx.bilirubinDirect.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_bilirubinDirect",
	value: {
		schemaId: "bilirubinDirect",
		title: messages.bilirubinDirect,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
